import { AIPanelToggleButton } from "components/footer/controls/AIPanelToggleButton";
import { EditModeButton } from "components/footer/controls/EditModeButton";
import { InstructorNotesPanelToggleButton } from "components/footer/controls/InstructorNotesPanelToggleButton";
import { UserPanelToggleButton } from "components/footer/controls/UserPanelToggleButton";
import { ProjectingButton } from "components/materials/presentation/ProjectingButton";
import { openProjectorView } from "components/materials/presentation/projector/projector-messaging";
import { useIsAssessing } from "components/materials/section/assessment/hooks";
import { t } from "i18n/i18n";
import { Button } from "mds/components/Button";
import { Menu, MenuDivider } from "mds/components/Menu";
import { useIsMdOrLarger } from "mds/hooks/use-responsive";
import { DotMenuVerticalIcon } from "mds/icons";
import { useAppSelector } from "store/index";
import { selectCurrentPageId, selectCurrentUserId } from "store/selectors";
import { startProjecting, usePresentation } from "utils/presentation";

export const FooterOptionsMenu = ({ hideEditModeButton }: { hideEditModeButton?: boolean }) => {
  const selectedPageId = useAppSelector(selectCurrentPageId);
  const isMobile = !useIsMdOrLarger();
  const isAssessing = useIsAssessing();
  const { isPresenting, unfeaturedTab, sectionId, presentedSessionId } = usePresentation();
  const userId = useAppSelector(selectCurrentUserId);

  const MenuButton = (
    <Button
      eventName="Bottom bar - 3-dot menu"
      kind="squareLegacy"
      size="l"
      title={t("common.options")}
      isSquare
      onClick={(e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      <DotMenuVerticalIcon />
    </Button>
  );

  const onProjecting = () => {
    if (!sectionId || !presentedSessionId || !selectedPageId) {
      return Promise.resolve();
    }
    openProjectorView(sectionId);
    return startProjecting(presentedSessionId, {
      // We add these fields to ensure the server validation passes,
      // just in case the projecting action is taken before any presenting action.
      presented_page_id: selectedPageId,
      presenting_user_id: userId,
    });
  };

  return (
    <Menu direction="top" menuButton={MenuButton} menuClassName="min-w-[180px]">
      {isMobile && !hideEditModeButton && (
        <>
          <EditModeButton isDisabled={isAssessing} />
          <MenuDivider />
        </>
      )}
      <AIPanelToggleButton isMenuItem />
      <InstructorNotesPanelToggleButton isMenuItem />
      <UserPanelToggleButton isMenuItem />

      {isPresenting && !unfeaturedTab && (
        <>
          <MenuDivider />
          <ProjectingButton isMenuItem onProject={onProjecting} />
        </>
      )}
    </Menu>
  );
};
